import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { InputDelayDirective } from './input-delay.directive';

@NgModule({
  declarations: [InputDelayDirective],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [InputDelayDirective],
})
export class InputDelayModule { }
